import React from "react";

/** What the running bundle is. Both values are stamped at build time by
 *  scripts/with-build-info.js (CRA inlines REACT_APP_* at compile time), so a
 *  phone showing this line is showing which deploy it is actually running —
 *  the whole reason the line exists is telling a cached old bundle from the
 *  new one without asking anyone to open devtools.
 *
 *  Reads `env` at call time rather than module load so tests can vary it. */
export const describeBuild = (env = process.env) => {
  const version = env.REACT_APP_VERSION || null;
  const sha = env.REACT_APP_BUILD_SHA && env.REACT_APP_BUILD_SHA !== "local"
    ? env.REACT_APP_BUILD_SHA
    : null;
  const text = `Version ${version || "—"} · ${sha ? `build ${sha}` : "dev build"}`;
  return { version, sha, text };
};

/** One muted, selectable line for the bottom of the profile menu. */
const AppVersion = ({ compact = false, style }) => {
  const { text } = describeBuild();
  return (
    <div
      className="app-version"
      data-testid="app-version"
      style={{
        padding: compact ? "6px 16px 10px" : "10px 20px 12px",
        fontSize: 11,
        lineHeight: 1.4,
        color: "#9CA3AF",
        userSelect: "text",
        WebkitUserSelect: "text",
        cursor: "text",
        ...style,
      }}
    >
      {text}
    </div>
  );
};

export default AppVersion;
